export default IconRings => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-rings" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
  <path d="M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
  <path d="M7 15v-11" />
  <path d="M17 15v-11" />
  <path d="M3 4h18" />
</svg>`;